import React from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import Contact from './pages/Contact'
import Odyssey from './pages/Odyssey'
import { initAnalytics, trackPageView } from './analytics'

function AnalyticsTracker() {
  const { pathname, search } = useLocation()

  React.useEffect(() => {
    initAnalytics()
  }, [])

  React.useEffect(() => {
    trackPageView(`${pathname}${search}`)
  }, [pathname, search])

  return null
}

export default function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/odyssey" element={<Odyssey />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          {/* Anything else → home */}
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
